import * as React from 'react';
import { CameraOutlined } from '@ant-design/icons';
import { Badge } from 'antd';

export const PhotoMaterialStyleLegend: React.FC = () => {
  return (
    <>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div>
          <Badge count={' '} showZero size="small" color="geekblue">
            <div
              style={{
                display: 'flex',
                border: '2px solid #91919e',
                borderRadius: '8px',
                width: '26px',
                height: '26px',
                justifyContent: 'center',
                alignItems: 'center',
                paddingRight: 'auto',
                paddingLeft: 'auto',
              }}
            >
              <CameraOutlined color="#91919e" />
            </div>
          </Badge>
        </div>

        <div style={{ marginLeft: '5px' }}>Фотоматериалы</div>
      </span>
    </>
  );
};
